import styled from 'styled-components';

import { MultiStepFormProvider } from 'components/form/MultiStepFormProvider';
import {
  BecomeFundraiserContextProps,
  BecomeFundraiserProvider,
  useBecomeFundraiser,
} from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';

import SelectType from './steps/SelectType';
import Summary from './steps/Summary';
import VerifyAccountNumber from './steps/VerifyAccountNumber';
import VerifyAccountType from './steps/VerifyAccountType';
import VerifyContactDetails from './steps/VerifyContactDetails';
import VerifyOrganization from './steps/VerifyOrganization';
import VerifyRoutingNumber from './steps/VerifyRoutingNumber';

const Container = styled.div`
  width: 100%;
  display: flex;
`;

const BecomeFundraiserForm = () => {
  const { isEditMode } = useBecomeFundraiser();
  return (
    <Container data-testid={'become-fundraiser-form'}>
      <MultiStepFormProvider>
        {!isEditMode && <SelectType />}
        <VerifyOrganization />
        <VerifyRoutingNumber />
        <VerifyAccountNumber />
        <VerifyAccountType />
        <VerifyContactDetails />
        <Summary />
      </MultiStepFormProvider>
    </Container>
  );
};

const BecomeFundraiserFormWithContext = ({ user, fundraiserData }: BecomeFundraiserContextProps) => {
  return (
    <BecomeFundraiserProvider user={user} fundraiserData={fundraiserData}>
      <BecomeFundraiserForm />
    </BecomeFundraiserProvider>
  );
};

export default BecomeFundraiserFormWithContext;
